import { MenuItem } from "@mui/material";
import type { ShiftSegment, TrendsPageFilterStateType } from "types/types";
import { useDispatch } from "react-redux";
import { updateTrendsPageFilterState } from "../../../providers/GlobalStateProvider";
import { groupShiftsByName } from "./filtersDrawerUtils";
import {
  useTrendsPageFilterState,
  useShifts,
} from "utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";

const FilterByShiftDropdownItems = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { trendsPageFilterState } = useTrendsPageFilterState();
  const shifts = useShifts();

  // show if we have more than the default "all" shift group + 1 other
  const shiftsGroupedByName: {
    [shiftName: string]: ShiftSegment[];
  } = groupShiftsByName(shifts);
  const ckey = useCustomerKey();
  const isReady =
    Object.values(shiftsGroupedByName).length >
    // for ravenjest, wait for all shifts to be loaded (prevents test failure when cypress tries to click, but menu closes on re-render)
    (ckey === "ravenjest" ? 4 : 2);

  if (!isReady) {
    return null;
  }

  const handleShiftDropdownChange = shiftName => {
    const newShiftNameFilter: string = shiftName;
    if (trendsPageFilterState.shiftName !== newShiftNameFilter) {
      const newFilterState: TrendsPageFilterStateType = {
        ...trendsPageFilterState,
        shiftName: newShiftNameFilter,
      };
      dispatch(updateTrendsPageFilterState({ newFilterState }));
    }
  };

  return (
    <>
      {Object.keys(shiftsGroupedByName)
        .sort()
        .map(shiftName => {
          return (
            <MenuItem
              key={shiftName}
              value={shiftName}
              onClick={() => {
                handleShiftDropdownChange(shiftName);
                handleClose();
              }}
            >
              {shiftName}
            </MenuItem>
          );
        })}
    </>
  );
};

export default FilterByShiftDropdownItems;
